"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.file_configTape = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const pointer_methods_1 = require("@finley-technologies/pointer-methods");
const commonTapeNode_1 = require("../../commonTapeNode");
const utils_1 = require("../../utils");
const types_1 = require("./types");
const { isNode, isIntermediateRecord, ...otherProps } = (0, commonTapeNode_1.commonTapeNodeUtils)(types_1.nodeType, types_1.artifactType, types_1.UIConfigSchema);
// create a new UI node of this type.
const createNewNode = ({ id, orgSlug, suggestedSerialNumber, creditFacilitySlug, nodeToCopy, }) => {
    const friendlyName = `Supplemental`;
    const nodeData = {
        metadata: {
            tapeBuilderNodeId: id,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug: `${_.camelCase(friendlyName)}_${suggestedSerialNumber}`,
            borrowerConfig: {
                internalSlack: {
                    channel: '#borrower-internal',
                    webhookUri: 'create webhook uri',
                },
                cashBalancePreference: 'current',
                slug: orgSlug,
                digestEmailSections: [
                    'borrowingBaseSummary',
                    'concentrationLimit',
                    'ineligibleReceivables',
                ],
            },
            creditFacilityConfigs: [
                {
                    creditFacilitySlug,
                    cashBalancesFeedMethodPointer: 'generic',
                    digestEmailDeliveryCadence: [],
                    isEnabledForBorrowingBaseReserve: true,
                    isBorrowingBaseReservePositiveExcessCollectionsOverReserve: false,
                    receivablesSaleAgreementGenerationConfig: {
                        receivablesSaleAgreement: false,
                    },
                },
            ],
        },
    };
    if (nodeToCopy) {
        (0, common_1.finleyAssert)(isNode(nodeToCopy), `node must be a ${types_1.nodeType} node`);
        nodeData.configuration = _.cloneDeep(nodeToCopy.configuration);
        nodeData.configuration.artifactSlug = (0, utils_1.updateArtifactSlug)(nodeData.configuration.artifactSlug, suggestedSerialNumber);
    }
    return nodeData;
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = ({ graph, node, getUINode, }) => {
    (0, common_1.finleyAssert)(isNode(node), `node must be a ${types_1.nodeType} node`);
    const errors = (0, utils_1.checkEdges)({
        node,
        graph,
        isAllowedInputNode: () => false,
        getUINode,
        minInputs: 0,
        maxInputs: 0,
        minOutputs: 0,
        maxOutputs: 0, // there could be many outputs to tapes.
    });
    const configNodes = graph.nodes.filter(({ metadata }) => metadata.tapeBuilderNodeType === types_1.nodeType);
    // there can be only one config node in the graph.
    // if there are multiple, then one of the nodes should report the error.
    if ((0, utils_1.getLowestNodeIdIfMultiple)(configNodes) === node.metadata.tapeBuilderNodeId) {
        errors.push(`There can only be one ${types_1.nodeType} node in the graph. Found ${configNodes.length}`);
    }
    return errors;
};
const validateIntermediateTape = ({ tape, creditFacilitySlugs, }) => {
    (0, common_1.finleyAssert)(isIntermediateRecord(tape), `validateIntermediateTape: tape is not an ${types_1.artifactType}`);
    (0, common_1.finleyAssert)(tape.type === 'configTape', `node is not a configTape, found: [tape.type:${tape.type}]`);
    const configErrors = [];
    const { configuration } = tape;
    const creditFacilityConfigs = configuration.creditFacilityConfigs;
    const configuredCFSlugs = new Set();
    creditFacilityConfigs.forEach((creditFacilityConfig) => {
        if (configuredCFSlugs.has(creditFacilityConfig.creditFacilitySlug)) {
            configErrors.push(`configTape: Tape configuration contains duplicate [creditFacilitySlug:${creditFacilityConfig.creditFacilitySlug}]`);
        }
        configuredCFSlugs.add(creditFacilityConfig.creditFacilitySlug);
        // ensure that configuration references only creditFacilitySlugs that exist in the graph
        if (!creditFacilitySlugs.includes(creditFacilityConfig.creditFacilitySlug)) {
            configErrors.push(`configTape: Tape configuration contains unknown [creditFacilitySlug:${creditFacilityConfig.creditFacilitySlug}]`);
        }
        // ensure that the cashBalancesFeedMethodPointer can be resolved
        if (creditFacilityConfig.cashBalancesFeedMethodPointer) {
            const method = (0, pointer_methods_1.resolveCashBalanceFeedPointer)(creditFacilityConfig.cashBalancesFeedMethodPointer);
            if (!method) {
                configErrors.push(`configTape: Tape configuration contains unknown  [cashBalancesFeedMethodPointer:${creditFacilityConfig.cashBalancesFeedMethodPointer}]`);
            }
        }
    });
    return configErrors;
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.file_configTape = {
    // what should node say on the tape-buider node creation menu.
    nodeTypeText: 'Config',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: true,
    isFinal: true,
    // operatin nodes dont render badges.
    badgeTexts: ['Config'],
    // creates sample configuration for this node.
    createNewNode,
    // typeguard that checks if the node is of this type.
    isNode,
    isIntermediateRecord,
    ...otherProps,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape,
};
//# sourceMappingURL=uinode.js.map